import React, { useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import { TaskLog } from "../types/TaskLog";
import { fetchTaskLogsAction } from "../redux/actions/taskLogActions";
import { useDispatch } from "react-redux";

interface Props {
  list: TaskLog[];
  onEdit?: (item: TaskLog) => void;
  onDelete?: (id: number) => void;
}

const TaskLogList: React.FC<Props> = ({ list, onEdit, onDelete }) => {
  const dispatch = useDispatch<any>();

  useEffect(() => {
    
    dispatch(fetchTaskLogsAction());
  }, []);
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          {/* <th>Task ID</th> */}
          <th>S.No</th>
          <th>Event Type</th>
          <th>Message</th>
          <th>Create By</th>
          {/* <th>Actions</th> */}
        </tr>
      </thead>
      <tbody>
        {list.map((log, index) => (
          <tr key={log.id}>
            {/* <td>{log.taskId}</td> */}
            <td>{index + 1}</td>
            <td>{log.eventType}</td>
            <td>{log.message}</td>
            <td>{log.createBy}</td>
            {/* <td>
              <Button
                variant="warning"
                onClick={() => onEdit(log)}
                size="sm"
                className="mr-2"
              >
                Edit
              </Button>
              <Button
                variant="danger"
                onClick={() => onDelete(log.id)}
                size="sm"
              >
                Delete
              </Button>
            </td> */}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TaskLogList;
